export default function ProjectOverview() {
  const targetAudience = [
    {
      icon: 'ri-graduation-cap-line',
      title: 'طلاب الجامعات والشباب',
      description: 'مساحة حرة للتعلم والنمو والاسترخاء'
    },
    {
      icon: 'ri-rocket-line',
      title: 'رواد الأعمال في المراحل المبكرة',
      description: 'بيئة لصناعة الأفكار واختبارها'
    },
    {
      icon: 'ri-building-line',
      title: 'أصحاب المشاريع الناشئة',
      description: 'مساحات عمل مشتركة ودعم متكامل'
    }
  ];

  const corporateBenefits = [
    {
      icon: 'ri-award-line',
      title: 'بناء العلامة التجارية',
      description: 'حضور كراعٍ للابتكار والمواهب'
    },
    {
      icon: 'ri-team-line',
      title: 'الوصول المباشر للمواهب',
      description: 'اكتشاف وتوظيف أفضل الكفاءات'
    },
    {
      icon: 'ri-heart-line',
      title: 'أثر مجتمعي مستدام',
      description: 'تحقيق تنمية اجتماعية حقيقية'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'حضور استراتيجي',
      description: 'موقع طويل المدى في منظومة ريادة الأعمال'
    }
  ];

  const features = [
    {
      icon: 'ri-building-line',
      title: 'مساحة عمل مشتركة',
      description: 'بيئة عمل احترافية مجهزة بأحدث التقنيات',
      stats: '1,300 م²'
    },
    {
      icon: 'ri-team-line',
      title: 'برامج تطوير',
      description: 'ورش عمل وتدريبات متخصصة',
      stats: '100+ برنامج سنويًا'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'احتضان المشاريع',
      description: 'دعم ومتابعة للمشاريع الناشئة',
      stats: '50 - 80 مشروع'
    },
    {
      icon: 'ri-links-line',
      title: 'شبكة علاقات',
      description: 'ربط مع خبراء وشركات رائدة',
      stats: '15+ شريك'
    }
  ];

  return (
    <section className="py-20 bg-white relative overflow-hidden">
      {/* Background Image with Gradient Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="/youth-challenges.png"
          alt="بيئة عمل مشتركة"
          className="w-full h-full object-cover opacity-5"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-white via-white/98 to-white"></div>
      </div>

      <div className="container mx-auto px-6 lg:px-12 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            الملخص التنفيذي
          </h2>
          <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed mb-8">
            في عالم يتغير بشكل متسارع، لم تعد مساحات العمل مجرد مكاتب وكراسي وإنترنت، بل أصبحت بيئات لصناعة الأفكار واختبارها، وبناء العقول، واكتشاف القادة، وربط المواهب بالفرص، ومساحات حرة للشباب والطلاب لقضاء الأوقات والاسترخاء والقراءة.
          </p>
          <div className="inline-block bg-gradient-to-r from-[#FF6B6B]/10 to-[#FF8E53]/10 px-8 py-4 rounded-2xl border border-[#FF6B6B]/20">
            <p className="text-lg font-semibold text-gray-800">
              المشروع ليس مساحة عمل فقط، بل بيئة متكاملة تجمع بين العمل، التطوير، التفكير، الترفيه، وبناء المستقبل
            </p>
          </div>
        </div>

        {/* Target Audience */}
        <div className="mb-20">
          <h3 className="text-3xl font-bold text-gray-900 mb-10 text-center">
            الفئات المستهدفة
          </h3>
          <div className="grid md:grid-cols-3 gap-8">
            {targetAudience.map((item, index) => (
              <div
                key={index}
                className="group bg-gradient-to-br from-white to-[#FFF5F3] p-8 rounded-2xl border border-gray-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-[#FF6B6B] to-[#FF8E53] rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <i className={`${item.icon} text-white text-3xl`}></i>
                </div>
                <h4 className="font-bold text-xl text-gray-900 mb-3">
                  {item.title}
                </h4>
                <p className="text-gray-600 leading-relaxed">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Corporate Benefits */}
        <div>
          <h3 className="text-3xl font-bold text-gray-900 mb-4 text-center">
            نموذج الاستثمار الاجتماعي
          </h3>
          <p className="text-lg text-gray-600 text-center mb-10 max-w-3xl mx-auto">
            تتحمل الشركات الكبرى تكاليف التأسيس والتشغيل، مقابل عوائد استراتيجية ومجتمعية
          </p>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {corporateBenefits.map((benefit, index) => (
              <div
                key={index}
                className="group bg-gradient-to-br from-white to-[#FFF5F3] p-8 rounded-2xl border border-gray-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-[#FF6B6B] to-[#FF8E53] rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <i className={`${benefit.icon} text-white text-3xl`}></i>
                </div>
                <h4 className="font-bold text-xl text-gray-900 mb-3">
                  {benefit.title}
                </h4>
                <p className="text-gray-600 leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
